import React, { useContext } from 'react';
import Slider from 'react-slick';
import ConfigContext from '../../contexts/ConfigContext';
import { useGetTrucksQuery } from '../../redux/slices/truckSlice';

// Components
import TruckTease from './TruckTease';

import 'slick-carousel/slick/slick.css';
import styles from './FeaturedTrucks.module.postcss';
import ErrorBoundary from '../shared/ErrorBoundary';

const defaultSettings = {
  slidesToShow: 4,
  slidesToScroll: 2,
  infinite: false,
  lazyLoad: 'anticipated',
  waitForAnimate: false,
  useCSS: true,
  useTransform: true,
  responsive: [
    {
      breakpoint: 1350,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 1250,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 732,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

function FeaturedTrucks({ options, title, noTitle, noWrapper, sliderSettings, showMenuLinks, className, noLazy }) {
  const { vehicle_type } = useContext(ConfigContext);
  const settings = { ...defaultSettings, ...sliderSettings };
  const fetchOptions = { page_size: 10, for_featured: true, random_order: options && !options.featured, ...options };

  const { data = {}, isSuccess } = useGetTrucksQuery(fetchOptions);
  const featuredTrucks = data.featured_trucks || [];

  if (!isSuccess) {
    return (<div className={styles.FeaturedTrucks}></div>);
  }

  if (featuredTrucks.length === 0) {
    return null;
  }

  const slides = featuredTrucks.map((truck, index) => {
    let skipLazyLoading = false;

    if (noLazy && index === 0) {
      skipLazyLoading = true;
    }

    return (
      <div key={'vendors-' + truck.id}>
        <TruckTease truck={truck} showMenuLink={showMenuLinks} noLazy={skipLazyLoading} />
      </div>
    );
  });

  const content = (
    <>
      { !noTitle && <h2>{title || `Featured food ${vehicle_type.toLowerCase()}s`}</h2> }
      <div>
        <Slider className={styles.FeaturedTrucks} {...settings}>
          {slides}
        </Slider>
      </div>
    </>
  );

  if (noWrapper) {
    return content;
  }

  return <div className={className || 'Section'}>{content}</div>;
}

// react-slick / third-party render paths can throw; a crash drops this carousel and keeps the rest of the page.
// Wrapped here rather than at every call site.
function FeaturedTrucksBoundary(props) {
  return (
    <ErrorBoundary name='FeaturedTrucks'>
      <FeaturedTrucks {...props} />
    </ErrorBoundary>
  );
}

export default FeaturedTrucksBoundary;
